import { useAppSelector, useAppTranslation } from "@/utils";
import { type SDKRequestInit, bnplConsumerApis } from "@payping/api";
import { FiMoreVertical, PhRxCircle } from "@payping/icons";
import { Button, Flex, Modal, Popover, Typography, useMessagedAsyncFn } from "@payping/web-components";
import { useState } from "react";
import { useSearchParams } from "react-router";

const GetOrderCancelOrder = () => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [searchParams] = useSearchParams();
  const [showPopover, setShowPopover] = useState(false);
  const trackingCode = searchParams.get("trackingCode") || "";

  const { t } = useAppTranslation();

  const handleOpenCancelModal = () => setShowCancelModal(true);
  const handleCloseCancelModal = () => setShowCancelModal(false);

  const handleClosePopover = () => setShowPopover(false);

  const [{ loading }, cancelOrder] = useMessagedAsyncFn(
    () => bnplConsumerApis.orderCancelConsumer({ trackingCode }, { isRaw: true } as SDKRequestInit),
    [trackingCode],
  );

  const order = useAppSelector((state) => state.bnplConsumer.order);

  const handleCancelOrder = () => {
    cancelOrder().then((res) => {
      if (res instanceof Error) {
        return;
      }
      if (order.merchantRedirectUrl) {
        window.location.href = order.merchantRedirectUrl;
        return;
      }
      window.close();
    });
  };

  // use can not cancel order
  if (!order.canCancel) return null;

  return (
    <>
      <Popover
        onOpenChange={setShowPopover}
        open={showPopover}
        content={
          <Flex vertical>
            <Button
              type="text"
              size="small"
              onClick={() => {
                handleOpenCancelModal();
                handleClosePopover();
              }}
            >
              <Flex gap={"small"} align="center">
                <PhRxCircle width={20} />
                <Typography.Text className="tw:font-medium!">
                  {t("pay.getOrder.cancelAuthorization.title")}
                </Typography.Text>
              </Flex>
            </Button>
          </Flex>
        }
        placement="bottomRight"
      >
        <button style={{ background: "none" }} className="tw:border-none tw:outline-none">
          <FiMoreVertical width={"20px"} />
        </button>
      </Popover>

      {showCancelModal ? (
        <Modal
          centered
          open={showCancelModal}
          onCancel={() => {
            if (loading) return;
            handleCloseCancelModal();
          }}
          title={t("pay.getOrder.cancelAuthorization.title")}
          footer={
            <Flex gap={"small"}>
              <Button
                disabled={loading}
                onClick={() => {
                  handleCloseCancelModal();
                }}
              >
                {t("common.no")}
              </Button>
              <Button
                loading={loading}
                onClick={() => {
                  handleCancelOrder();
                }}
                type="primary"
              >
                {t("common.yes")}
              </Button>
            </Flex>
          }
        >
          <Typography.Paragraph className="tw:m-0!">
            {t("pay.getOrder.cancelAuthorization.content")}
          </Typography.Paragraph>
        </Modal>
      ) : null}
    </>
  );
};

export default GetOrderCancelOrder;
